<template>
  <v-combobox
    :data-testid="dataTestid" v-bind="$attrs" v-on="$listeners" :items="fonctions" />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fonctions: [
        { header: "Sélectionner une valeur, ou saisissez une valeur autre" },
        "Président(e)",
        "Trésorier(ère)",
        "Secrétaire",
        "Liquidateur",
      ],
    };
  },
};
</script>
